import dayjs from "dayjs";
import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    month: dayjs(),
    selectedUnitIds: [0],
    loading: false,
    workStatusId: null,
    workStatusName: null,
    inMultiStatus: false,
};

const [
    viewModel,
    update, reset,
] = BaseUtil.getViewModel(initState, type);

export {
    update, reset,
};

export default viewModel;
